import { useQuery } from "@tanstack/react-query";
import { getSearchAccCoa } from "../../../core/services";
export const useGetSearchAccCoa = (searchParams) => {
    return useQuery({
        queryKey: ["accCoa", searchParams],
        queryFn: () => getSearchAccCoa(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
